import React from 'react';
import Popover from 'wix-rich-content-common/libs/Popover';
import PopoverWrapper from 'wix-rich-content-common/libs/PopoverWrapper';
import InfoIcon$1 from '../Icons/InfoIcon.js';

const InfoIconWithPopover = ({ forceVisibility = false, children, langDir }) => /* @__PURE__ */ React.createElement(PopoverWrapper, null, ({ showTooltip, hideTooltip, active, parent }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(InfoIcon$1, { onMouseEnter: showTooltip, onMouseLeave: hideTooltip }), /* @__PURE__ */ React.createElement(Popover, { active: forceVisibility || active, parent, langDir }, children)));

export { InfoIconWithPopover as default };
//# sourceMappingURL=InfoIconWithPopover.js.map
